import styles from './pageLayout.module.scss'
import { Outlet } from "react-router";
import { LeftMenu } from "./leftMenu/leftMenu";
import { HeaderMenu } from "./headerMenu/headerMenu";

export const PageLayout = () => {
  return (
    <div className={styles.container}>
      <LeftMenu />
      <div className={styles.rightPanel}>
        <HeaderMenu />
        <Outlet/>
      </div>
    </div>
  )
}